import {QuestionMarkupItem} from './QuestionMarkup.types';

export const defaultPositions = [
    QuestionMarkupItem.Label,
    QuestionMarkupItem.Image,
    QuestionMarkupItem.Control,
    QuestionMarkupItem.Comment,
];
